<template>
  <BorderWrapper>
    <div class="contianer">
      <controlActionsButtons
        :ActionsList="[
          { name: 'סוכנים', path: '/' },
          { name: 'אזורי חלוקה', path: '/' },
        ]"
        :selectedAction="selectedAction"
        @selectAction="selectAction"
        mode="controlPanel"
      />
      <!-- <SideBarList
        v-if="getUserRole?.agentapp && selectedAction === 'סוכנים'"
        :Categories="agentsList"
        queryKey="agentId"
        defaultValue="סוכן"
        mode="customers"
      /> -->
      <!-- <AgentMultiSelector
        v-if="getUserRole?.agentapp && selectedAction === 'סוכנים'"
        :agents="agentsList"
        :selectedAgents="selectedAgents"
        @toggle-agent="toggleAgent"
      /> -->
      <v-select
        max-width="400"
        color="#6d1106"
        v-if="getUserRole?.agentapp && selectedAction === 'סוכנים'"
        v-model="selectedAgents"
        :items="agentsList"
        :item-title="'name'"
        :item-value="'id'"
        label="בחירת סוכנים"
        rounded="lg"
        variant="outlined"
        multiple
        chips
        closable-chips
        clearable
      />
      <div
        v-if="controlPanelList.length > 0"
        :class="[scrollList]"
        class="grid"
      >
        <DistributionAreas
          :isLoading="isLoading"
          v-for="(controlPanel, index) in controlPanelList"
          :tableLineBackground="isOdd(index + 1) ? '#ffefdb' : 'transparent'"
          :key="controlPanel"
          :distributionArea="controlPanel"
          :isAgents="isAgents"
        />
      </div>
    </div>
  </BorderWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import BorderWrapper from "../UI/BorderWrapper.vue";
import controlActionsButtons from "../helpers/controlActionsButtons.vue";
import DistributionAreas from "../helpers/DistributionAreas.vue";
// import SideBarList from "../menus/SideBarList.vue";
import AuthService from "../../services/AuthService";
// import AgentMultiSelector from "../helpers/AgentMultiSelector.vue";
import store from "../../store";
import { isOdd } from "../../utilities";

export default {
  components: {
    BorderWrapper,
    controlActionsButtons,
    DistributionAreas,
    // SideBarList,
    // AgentMultiSelector,
  },
  computed: {
    scrollList() {
      return !this.isMobile ? "scroll-list" : "";
    },
    ...mapGetters({
      Parts: "Parts/getParts",
      getCustname: "AuthModule/getCustname",
      getUserLang: "AuthModule/getUserLang",
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isDesktop: "isDesktop",
      getAgentsList: "ControlPanel/getAgentsList",
      getDistLinesList: "ControlPanel/getDistLinesList",
      getUserRole: "AuthModule/getUserRole",
    }),
    isRestricModelOpen() {
      return !this.getUserRole?.agentapp;
    },
    agentsList() {
      return this.getAgentsList.map((agent) => {
        return {
          id: agent.agent,
          name: agent.agentname,
        };
      });
    },
    controlPanelList() {
      let controlPanelList = this.isAgents
        ? this.getAgentsList
        : this.getDistLinesList;
      if (this.selectedAgents.length > 0 && this.isAgents) {
        controlPanelList = controlPanelList.filter((agent) =>
          this.selectedAgents.includes(agent.agent)
        );
      }
      // if (this.$route.query.agentId && this.isAgents) {
      //   controlPanelList = controlPanelList.filter(
      //     (agent) => agent.agent == this.$route.query.agentId
      //   );
      // }
      return controlPanelList;
    },
  },
  async mounted() {
    try {
      this.isLoading = true;
      await AuthService.getBigData("control-panel-agents-list");
      await AuthService.getBigData("control-panel-distlines-list");
      // if (this.isDesktop) {
      const agentRequests = store.getters["AgentRequests/getAgentRequests"];
      if (agentRequests?.length == 0) {
        await AuthService.getBigData("agentRequests");
      }
      // }
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
    // this.intervalId = setInterval(async () => {
    //   this.$store.dispatch("ControlPanel/agentsList");
    //   this.$store.dispatch("ControlPanel/distLinesList");
    //   if (!this.getUserRole?.agentapp)
    //     this.$store.dispatch("Customers/getCustomers");
    // }, 3600000);
    this.intervalTwoId = setInterval(async () => {
      if (!this.isMobile) {
        this.$store.dispatch("AgentRequests/agentRequestsIntervalUpdate");
      }
    }, 3600000);
  },
  data() {
    return {
      selectedAgents: [],
      isLoading: false,
      isModalOpen: false,
      selectedAction: "סוכנים",
      isAgents: true,
      intervalId: null,
      scrollHeight: "100vh - 58px - 260px",
    };
  },
  methods: {
    isOdd(number) {
      return isOdd(number);
    },
    toggleAgent(month) {
      const index = this.selectedAgents.indexOf(month);
      if (index === -1) {
        this.selectedAgents.push(month);
      } else {
        this.selectedAgents.splice(index, 1);
      }
    },
    selectAction(action) {
      this.selectedAction = action.name;
      if (action.name === "סוכנים") {
        this.isAgents = true;
        this.scrollHeight = "100vh - 58px - 260px";
      } else {
        this.isAgents = false;
        this.scrollHeight = "100vh - 260px";
      }
    },
  },
  unmounted() {
    this.$store.commit("setIsShowDesktopHome", false);
    clearInterval(this.intervalId);
    clearInterval(this.intervalTwoId);
  },
};
</script>

<style scoped lang="scss">
.scroll-list {
  overflow-y: scroll;
  max-height: calc(v-bind(scrollHeight));
  padding-bottom: 100px;
}
.contianer {
  padding: 0px 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@include media(mobile) {
  .modal-container {
    width: 99% !important;
    padding: 5px !important;
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(390px, 1fr));
  justify-items: center;
  gap: 32px;
}

@include media(tablet, smallLaptop) {
  .grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
  }
}

@media screen and (max-width: 1000px) {
  .grid {
      grid-template-columns: repeat(1, 1fr) !important;
      gap: 16px;
  }

}


//old
.search {
  width: 100%;
  margin-bottom: 50px;
  margin-top: 15px;
}
* {
  text-align: center;
}
h3 {
  font-size: 20px;
  margin: 0;
  margin-top: 100px;
  margin-bottom: 10px;
  font-weight: 600;
}
h2 {
  font-size: 30px;
  margin: 0;
  color: $primaryColor;
}
.col {
  float: unset;
}
img {
  width: auto;
  height: 340px;
  margin: 0 auto !important;
  display: block;
}
</style>
